import Axios from 'axios'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { isAxiosError } from '../../../../Helpers/axiosTypes'
import { isC1ApiError } from '../../../../Helpers/c1ApiTypes'

export interface BulkContactExport {
  bceExecutionId: number,
  jobStartTime: number,
  jobName: string,
  numberOfContactsSubmitted: number,
  numberOfContactsExported: number,
  numberOfContactsFailed: number,
  numberOfInvalidContacts: number,
  numberOfTotalContacts: number,
  jobOwnerPersonId: number,
  jobOwnerFirstName: string,
  jobOwnerLastName: string,
  jobStatus: string,
}

const getBulkContactExports = () => Axios.get<BulkContactExport[]>('/api/rest/wfo/contact/export/bulk/floexecution').then(resp => resp.data)

export interface UseBulkContactExportsResult {
  data: BulkContactExport[] | undefined,
  isLoading: boolean,
  refresh: () => void,
  hasError: boolean,
  errorMessage: string,
  errorRequestId: string,
  resetError: () => void,
}

export function useBulkContactExports(): UseBulkContactExportsResult {
  const showError = (message: string, requestId = ''): void => {
    setHasError(true)
    setErrorMessage(message)
    setErrorRequestId(requestId)
  }
  const handleFetchError = (error: unknown): void => {
    if (!isAxiosError(error) || !error.response) {
      showError(t('defaultError'))
    } else if (!isC1ApiError(error.response.data)) {
      showError(error.response.statusText)
    } else {
      showError(error.response.data.errorMessage, error.response.data.requestId)
    }
  }
  const resetError = () => {
    setHasError(false)
  }
  const refresh = () => {
    setRefreshCounter(refreshCounter + 1)
  }
  const { t } = useTranslation()
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorRequestId, setErrorRequestId] = useState('')
  const [refreshCounter, setRefreshCounter] = useState(0)
  const { data, isLoading } = useQuery(
    ['bulkContactExports', refreshCounter], // invalidates cache when refresh button is pressed
    getBulkContactExports,
    { onError: handleFetchError, retry: false },
  )
  return { data, errorMessage, errorRequestId, hasError, isLoading, refresh, resetError }
}
